<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fas fa-calendar</v-icon>
        <h1 class="title ml-2">Programación</h1>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <v-select
              :items="dias"
              v-model="diaSelected"
              label="Día de la semana"
              item-text="label"
              item-value="value"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
            <v-btn
              @click="showNew = true"
              color="primary"
            >
              <v-icon left>fas fa-plus</v-icon>
              Agregar
            </v-btn>
            <v-btn
              color="accent"
              @click="showSort()"
              class="ml-2"
            >
              <v-icon left>fas fa-sort</v-icon>
              Ordenar
            </v-btn>
          </v-col>
        </v-row>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Horario</th>
                <th>Nombre</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in programas" :key="item.id">
                <td>{{item.horario}}</td>
                <td>{{item.nombre}}</td>
                <td class="max-width-120">
                  <v-btn fab text color="primary" @click="showItem(item)">
                    <v-icon>fas fa-list</v-icon>
                  </v-btn>
                  <v-btn fab text color="secondary" @click="editItem(item)">
                    <v-icon>fas fa-edit</v-icon>
                  </v-btn>
                  <v-btn fab text color="error" @click="deleteItem(item.id)">
                    <v-icon>fas fa-trash</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <!-- ------------------------------------------------------------------- -->
    <!-- ordenar programacion -->
    <!-- ------------------------------------------------------------------- -->
    <v-dialog v-model="showOrdenar" max-width="600">
      <sort-programacion
        :items="sortProgramas"
        @close="showOrdenar = false"
        @save="updateSort()"
      ></sort-programacion>
    </v-dialog>
    <!-- ------------------------------------------------------------------- -->
    <!-- guardar programa -->
    <!-- ------------------------------------------------------------------- -->
    <v-dialog v-model="showNew" max-width="600">
      <save-programa
        ref="programaNew"
        @close="showNew = false"
        @save="savePrograma"
      ></save-programa>
    </v-dialog>
    <!-- ------------------------------------------------------------------- -->
    <!-- modificar programa -->
    <!-- ------------------------------------------------------------------- -->
    <v-dialog v-model="showUpdate" max-width="600">
      <edit-programa
        title="Modificar programa"
        icon="fas fa-edit"
        v-model="programaEdit"
        @close="showUpdate = false"
        @save="updatePrograma"
      ></edit-programa>
    </v-dialog>
    <!-- ------------------------------------------------------------------- -->
    <!-- mostrar detalle -->
    <!-- ------------------------------------------------------------------- -->
    <v-dialog v-model="showDetail" max-width="600">
      <show-programa
        v-model="programaShow"
        @close="showDetail = false"
      ></show-programa>
    </v-dialog>
    <!-- ------------------------------------------------------------------- -->
    <!-- loader -->
    <!-- ------------------------------------------------------------------- -->
    <loader v-model="loading"></loader>
  </v-container>
</template>

<script>
import SortProgramacion from '../components/SortProgramacion'
import EditPrograma from '../components/EditPrograma'
import SavePrograma from '../components/SavePrograma'
import ShowPrograma from '../components/ShowPrograma'
import Loader from '../components/Loader'
import dias from '../helpers/dias'
export default {
  data () {
    return {
      dias,
      loading: false,
      diaSelected: null,
      showOrdenar: false,
      showNew: false,
      showDetail: false,
      showUpdate: false,
      sortProgramas: null,
      programaNew: {
        descripcion: '',
        dia: '',
        inicio: '',
        fin: '',
        nombre: '',
        imagen: null
      },
      programaShow: null,
      programaEdit: null,
      programas: []
    }
  },
  components: {
    EditPrograma,
    Loader,
    SavePrograma,
    ShowPrograma,
    SortProgramacion
  },
  methods: {
    showSort () {
      this.sortProgramas = Object.assign([], this.programas)
      this.showOrdenar = true
    },
    getProgramas () {
      this.$http.programas
        .get(`?dia=${this.diaSelected}&_sort=orden:ASC`)
        .then(res => res.data)
        .then(res => {
          this.programas = res.map(i => {
            return {
              ...i,
              horario: `${i.inicio} - ${i.fin}`
            }
          })
        })
    },
    async savePrograma (datos) {
      this.loading = true
      if (!datos.imagen) {
        let dia = null
        if (datos.dia === 'semana') {
          const semana = this.dias.slice(0, 5)
          for (const item of semana) {
            await this.$http.programas.post('', { ...datos, dia: item.value })
          }
          dia = 'lunes'
        } else if (datos.dia === 'todos') {
          for (const item of this.dias) {
            await this.$http.programas.post('', { ...datos, dia: item.value })
          }
          dia = 'lunes'
        } else {
          await this.$http.programas.post('', datos)
        }
        this.diaSelected = dia || datos.dia
        this.getProgramas()
        this.showNew = false
        this.loading = false
        this.$refs['programaNew'].reset()
      } else {
        const config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        }
        const { imagen, ...data } = datos
        const formData = new FormData()
        formData.append('data', JSON.stringify(data))
        formData.append('files.imagen', imagen, imagen.name)
        this.$http.programas
          .post('', formData, config)
          .then(() => {
            this.diaSelected = datos.dia
            this.getProgramas()
            this.showNew = false
            this.loading = false
            this.$refs['programaNew'].reset()
          })
      }
    },
    showItem (item) {
      this.programaShow = item
      this.showDetail = true
    },
    editItem (item) {
      this.programaEdit = item
      this.showUpdate = true
    },
    deleteItem (id) {
      if (window.confirm('¿Estas seguro de borrar el registro?')) {
        this.$http.programas
          .delete(`/${id}`)
          .then(() => {
            this.getProgramas()
          })
      }
    },
    updatePrograma (dia) {
      this.loading = true
      if (this.programaEdit.imagen instanceof File) {
        const config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        }
        const { imagen, ...data } = this.programaEdit
        const formData = new FormData()
        formData.append('data', JSON.stringify(data))
        formData.append('files.imagen', imagen, imagen.name)
        this.$http.programas
          .put(`/${this.programaEdit.id}`, formData, config)
          .then(() => {
            this.getProgramas()
            this.showUpdate = false
            this.diaSelected = dia
            this.loading = false
          })
      } else {
        this.$http.programas
          .put(`/${this.programaEdit.id}`, this.programaEdit)
          .then(() => {
            this.getProgramas()
            this.showUpdate = false
            this.diaSelected = dia
            this.loading = false
          })
      }
    },
    updateSort () {
      this.loading = true
      if (this.sortProgramas) {
        this.sortProgramas.forEach((item, index) => {
          item.orden = index
        })
        const arrPromises = this.sortProgramas.map(item => {
          return this.$http.programas.put(`/${item.id}`, item)
        })
        Promise.all(arrPromises)
          .then(() => {
            this.getProgramas()
            this.showOrdenar = false
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      }
    }
  },
  mounted () {
    this.diaSelected = 'lunes'
  },
  watch: {
    diaSelected () {
      this.getProgramas()
    }
  }
}
</script>
